export class EmisorNacionalRequest{
  idBinPk:number;
  idBancoFk:number;
  bin : string;
  usuarioAlta : string; //
  usuarioMod : string; //
  usuarioAutorizador : string; //
  fchAlta:string;
  fchMod:string;
  fchAutorizacion:string;
  regTemp:number;
  binInicio:number;
  binFinal:number;
  cd : string;
  BubBaseBinesIdBaseBinPk:number;
  BubBaseBinesDsc:string;
  BubBaseBinesSectorBm:string;
  BubBaseBinesNumeroBm:string;
  BubBaseBinesNombreCortoBm:string;
  BubBaseBinesManual:boolean;
  BubBaseBinesTpv:boolean;
  BubBaseBinesInterRedes:boolean;
  BubBaseBinesAtm:boolean;
  BubBaseBinesEcommerce:boolean;
  BubBaseBinesCargosAutomaticos:boolean;
  BubBaseBinesVentasTel:boolean;
  BubBaseBinesSucursal:boolean;
  BubBaseBinesPInterbancarios:boolean;
  BubBaseBinesSecure3d:boolean;
  BubBaseBinesStandIn:boolean;
  BubBaseBinesMarcasPropias:boolean;
  BubBaseBinesChip:boolean;
  BubBaseBinesCertMarca:boolean;
  BubBaseBinesBinVirtual:boolean;
  BubBaseBinesNfc:boolean;
  BubBaseBinesMst:boolean;
  BubBaseBinesWallet:boolean;
  BubBaseBinesPanDinamico:boolean;
  BubBaseBinesCcvCvcDinamico:boolean;
  BubBaseBinesNip:boolean;
  BubBaseBinesQps:boolean;
  BubBaseBinesTokenizacion:boolean;
  BubBaseBinesCardF1:string;
  BubBaseBinesPlanMsi:boolean;
  BubBaseBinesPlanMci:boolean;
  BubBaseBinesPlanSkip:boolean;
  comentarios:string;
  icaMc:string;

  vehiculo : string;
  montoMax : number;
  tipo : string;  //
  montoAcum : number;
  frecuencia : number;
  gpoInter : string;
  natBin : boolean;
  idBancoProsaFk : number; //
  idBancoEglobalFk : number; //
  pagos : boolean = false;
  marcaPrivada : boolean = false;
  tipoProd : string;
  marcaProducto : string;
  cuentaMaestra : number;
  standIn : boolean = false;
  responsable : string;
  nombreCorto : string;
  manual : boolean = false;
  tpv : boolean = false;
  interred : boolean = false;
  atm : boolean = false;
  //Comercio electronico
  ecommerce : boolean = false;
  cargoAutomatico : boolean = false;
  ventaTelefono : boolean = false;
  sucursal : boolean = false;
  pagoInterb : boolean = false;
  tarjetaChip : boolean = false;
  feCert : string;
  entidadCert : string;
  folioChip : string;
  lineaProdBx : string;
  producto : string;
  marcasPropias : string;
  tipoPlan03 : boolean = false;
  tipoPlan05 : boolean = false;
  tipoPlan07 : boolean = false;
  checkBin : boolean;
  casFim : number;
  marcaPropia : string; 
  idBinNacPk : number;
}

export class BaseRequest{

  bubBinesIdBinPk:number;
  idBaseBinPk:number;

  bubBinesBin :number;
  bubBinesBinInicio :number;
  bubBinesBinFinal :number;


  bubBinesBubCatInstitucionesIdInstitucionPk:number;
  bubBinesBubCatTipoBinIdTipoBinPk:number;
  bubBinesBubCatBinEstatusIdEstatusPk:number;
  bubBinesbubCatAccionBubCatAccion:number;
  
  bubCatProcesadoresIdProcesadorPk : number;
  bubCatNaturalezaBinesIdNaturalezaBinPk : number;
  bubCatMarcaProductoIdMarcaProductoPk : number;


  dsc:string;
  sectorBm:string;
  numeroBm:number;
  nombreCortoBm:string;
  manual:boolean;
  tpv:boolean;
  interRedes:boolean;
  atm:boolean;
  ecommerce:boolean;
  cargosAutomaticos:boolean;
  ventasTel:boolean;
  sucursal:boolean;
  pinterbancarios:boolean;
  secure3d:boolean;
  standIn:boolean;
  marcasPropias:boolean;
  chip:boolean;
  certMarca:boolean;
  binVirtual:boolean;
  nfc:boolean;
  mst:boolean;
  wallet:boolean;
  panDinamico:boolean;
  ccvCvcDinamico:boolean;
  nip:boolean;
  qps:boolean;
  tokenizacion:boolean;
  cardF1:string;
  planMsi:boolean;
  planMci:boolean;
  planSkip:boolean;
  comentarios:string;
  bubBinesFchAlta:string;
  bubBinesUsuarioAlta:string;
  fchAlta:string;
  usuarioAlta:string;
  nombreInstitucionBm:string;
  nombreProducto:string;
 // icaMc:string;
  ip:string;
  comentarioOpe:string;
}